import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import Checkbox from "@mui/material/Checkbox";
import { getIndustry } from "../services/FormService";
import IndustryForm from "./IndustryModal";
import { colourStyles } from "./SelectStyles";
import Chip from "@mui/material/Chip";

const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ transform: "scale(1.3)", marginRight: "10px" }}
      />
      <label>{props.label}</label>
    </components.Option>
  );
};

const CustomMultiValue = () => null;

const CustomValueContainer = ({ children, ...props }) => {
  const count = props.getValue().length;
  const customText =
    count === 1 ? `${count} industry selected` : `${count} industries selected`;

  return (
    <components.ValueContainer {...props}>
      {count > 0 ? (
        <div style={{ marginRight: "10px" }}>{customText}</div>
      ) : null}
      {children}
    </components.ValueContainer>
  );
};

const CustomMultiValueRemove = () => null;

const CustomIndicatorSeparator = () => null;

const CustomDropdownIndicator = (props) => {
  const { isTextboxOpen } = props.selectProps;

  const handleButtonClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    props.selectProps.onNewClick();
  };

  const handleMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <components.DropdownIndicator {...props}>
      <div style={{ display: "flex", alignItems: "center", zIndex: 999 }}>
        <div style={{ backgroundColor: "#f2f2f2" }}>
          {isTextboxOpen && (
            <IconButton
              onClick={handleButtonClick}
              onMouseDown={handleMouseDown}
              size="small"
            >
              <AddIcon style={{ fontSize: 18 }} />
            </IconButton>
          )}
        </div>
      </div>
    </components.DropdownIndicator>
  );
};

function IndustrySelect({
  selectedIndustry,
  setSelectedIndustry,
  industry,
  setIndustry,
}) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isTextboxOpen, setIsTextboxOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [showNewButton, setShowNewButton] = useState(false);

  useEffect(() => {
    getIndustry()
      .then((response) => {
        setIndustry(response.data);
      })
      .catch((error) => {
        console.log("Error fetching service types:", error);
      });
  }, []);

  // useEffect(() => {
  //   console.log("selectedIndustry", selectedIndustry);
  // }, [selectedIndustry]);

  const handleTextboxOpen = () => {
    setIsTextboxOpen(true);
  };

  const handleTextboxClose = () => {
    setIsTextboxOpen(false);
  };

  const handleChange = (selectedOptions) => {
    // console.log("selectedOptions", selectedOptions);
    setSelectedIndustry(selectedOptions || []);
  };

  const mapIndustriesToOptions = (industry) => {
    return industry.map((ind) => ({
      value: ind.slug,
      label: ind.name,
      ...ind,
    }));
  };

  const handleNewButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setModalIsOpen(true);
  };

  const handleMenuOpen = () => {
    setShowNewButton(true);
    setIsTextboxOpen(true);
  };

  const handleMenuClose = () => {
    setShowNewButton(false);
    setTimeout(() => {
      setIsTextboxOpen(false);
    }, 500);
  };

  const handleInputChange = (value) => {
    setInputValue(value);
  };

  return (
    <div style={{ position: "relative" }}>
      <IndustryForm
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        industry={industry}
        setIndustry={setIndustry}
      />
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
      ></div>
      <Select
        isMulti
        options={mapIndustriesToOptions(industry)}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.slug}
        maxMenuHeight={160}
        minMenuHeight={160}
        value={selectedIndustry}
        onChange={handleChange}
        onMenuOpen={handleMenuOpen}
        onInputChange={handleInputChange}
        onMenuClose={handleMenuClose}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option: CustomOption,
          MultiValue: CustomMultiValue,
          ValueContainer: CustomValueContainer,
          MultiValueRemove: CustomMultiValueRemove,
          IndicatorSeparator: null,
        }}
        placeholder="Select Industry"
        styles={colourStyles}
        isClearable={false}
      />
      {isTextboxOpen && inputValue === "" && (
        <button
        style={{
          position: "absolute",
          right: 3,
          bottom: "-12rem",
          zIndex: 999,
          textDecoration: "none",
          fontFamily: "Poppins",
          fontSize: "small",
          color: showNewButton ? "black" : "transparent",
          cursor: "pointer",
          border: "none",
          background: "none",
          padding: 0,
        }}
          onClick={handleNewButtonClick}
        >
          +New
        </button>
      )}
    </div>
  );
}

export default IndustrySelect;
